<template>
  <transition name="bg-modal">
    <div
      v-if="visible"
      class="bg-modal-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-notice-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bg-slip-modal-title"
        @keydown.esc.prevent="close"
      >
        <header class="bg-notice-modal__header">
          <h2 id="bg-slip-modal-title" class="bg-notice-modal__title">{{ title || $t('slip.detailDefaultTitle') }}</h2>
          <button
            type="button"
            class="bg-notice-modal__close"
            :aria-label="$t('common.close')"
            @click="close"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <div class="bg-notice-modal__meta">
          <span class="slip-table__status" :class="slipStatusClass(status)">
            {{ slipStatusLabel(status) }}
          </span>
          <span>{{ formattedDate }}</span>
        </div>

        <div class="bg-notice-modal__body">
          <p v-if="loading" class="bg-notice-modal__status">{{ $t('common.loading') }}</p>
          <p v-else-if="loadError" class="bg-notice-modal__status bg-notice-modal__status--error">{{ loadError }}</p>
          <div
            v-else
            class="bg-notice-modal__content"
            v-html="contentHtml"
          />
        </div>

        <footer class="bg-notice-modal__footer">
          <button type="button" class="bg-notice-modal__back" @click="close">{{ $t('common.backToList') }}</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { SystemService } from '@/services'
import { formatUtcDateTime } from '@/utils/format'
import { isSlipUnread, slipStatusLabel, slipStatusClass } from '@/utils/slip'

export default {
  name: 'BlackGoldSlipDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    slipIdx: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      loadError: '',
      title: '',
      contentHtml: '',
      regdate: '',
      status: 0
    }
  },
  computed: {
    formattedDate () {
      return formatUtcDateTime(this.regdate, { withSeconds: false })
    }
  },
  watch: {
    visible (open) {
      if (open && this.slipIdx != null) {
        this.loadDetail()
      }
      if (!open) {
        this.resetState()
      }
    },
    slipIdx (idx) {
      if (this.visible && idx != null) {
        this.loadDetail()
      }
    }
  },
  methods: {
    isSlipUnread,
    slipStatusLabel,
    slipStatusClass,
    close () {
      this.$emit('close')
    },
    resetState () {
      this.loading = false
      this.loadError = ''
      this.title = ''
      this.contentHtml = ''
      this.regdate = ''
      this.status = 0
    },
    toContentHtml (text) {
      if (!text) return ''
      const value = String(text)
      if (/<[a-z][\s\S]*>/i.test(value)) return value
      return value.replace(/\n/g, '<br>')
    },
    async loadDetail () {
      if (this.slipIdx == null || this.slipIdx === '') return
      this.loading = true
      this.loadError = ''
      this.title = ''
      this.contentHtml = ''
      this.regdate = ''
      try {
        const res = await SystemService.getSlipDetail(this.slipIdx)
        if (!res) {
          this.loadError = this.$t('slip.detailLoadError')
          return
        }
        if (res.data && res.data.code === 0 && res.data.data) {
          const data = res.data.data
          this.title = data.title || ''
          this.contentHtml = this.toContentHtml(data.text)
          this.regdate = data.regdate
          this.status = data.status
          this.$emit('read', data)
        } else {
          this.loadError = this.$t('slip.detailLoadError')
        }
      } catch (err) {
        this.loadError = this.$t('slip.detailLoadError')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
